export const getWarehousesEndpoint = '/berths/load_warehouses' as const
